import { render, staticRenderFns } from "./multiTrigon.vue?vue&type=template&id=50f6440c&"
import script from "./multiTrigon.vue?vue&type=script&lang=js&"
export * from "./multiTrigon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports